import { login, logout, login2FA, loginAdmin } from "./action";
import store from "../../store";

const model = {
  userLogin: (data) => {
    return store.dispatch(login(data));
  },
  userLoginAdmin: (data) => {
    return store.dispatch(loginAdmin(data));
  },
  userLogin2FA: (data) => {
    return store.dispatch(login2FA(data));
  },
  logout: () => {
    return store.dispatch(logout());
  },
};

export default model;
